import { render, staticRenderFns } from "./OptionLocationSettings.vue?vue&type=template&id=5323c9ca"
import script from "./OptionLocationSettings.vue?vue&type=script&lang=js"
export * from "./OptionLocationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports